import { CSPUrlsMap } from '../../routes/CSPUrlsMap';

export const TrupanionCSPConfig = {
  cspConfiguration: {
    partner: 'trupanion',
    partnerTitle: 'Trupanion Pet Insurance',
    auth0Config: {
      sit: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'trupanion-sit-petportal-auth.petsure.com.au',
        appClientId: '9Big76fgkklFcApG5HYVbqhURTzuRYXA',
        cspMfaUrl: 'https://trupanion-sit-petportal.au.auth0.com/mfa/',
        gen2CspUrl: ''
      },
      uat: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'trupanion-uat-petportal-auth.petsure.com.au',
        appClientId: 'oNYG9Fbt0SL0VmefT04VhqTPLLA9iI48',
        cspMfaUrl: 'https://trupanion-uat-petportal.au.auth0.com/mfa/',
        gen2CspUrl: ''
      },
      preprod: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'preprod-petportal-auth.trupanion.au',
        appClientId: 'o02DE3Yp8GZoJrqai7wPjZ8Jd9jn1PSt',
        cspMfaUrl: 'https://trupanion-preprod-petportal.au.auth0.com/mfa/',
        gen2CspUrl: ''
      },
      prod: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'petportal-auth.trupanion.au',
        appClientId: 'aW71GU7jneUCPMlaqulSEHlggrt95Tpu',
        defaultAudience: 'https://cspmiddlewareapi',
        cspMfaUrl: 'https://trupanion-prod-petportal.au.auth0.com/mfa/',
        gen2CspUrl: ''
      }
    },
    liveVetConfig: {
      sit: {
        vetChatAppModule: 'trupanion.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      uat: {
        vetChatAppModule: 'trupanion.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      preprod: {
        vetChatAppModule: 'trupanion.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      prod: {
        vetChatAppModule: 'trupanion.vetchat.com.au',
        vetChatUrl: 'https://livevet.vetchat.com.au',
        vetChatConsultationUrl: 'https://livevet.vetchat.com.au/consult'
      }
    },
    creditCardConfig: {
      sit: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      uat: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      preprod: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      prod: {
        formUrl: 'https://quickweb.westpac.com.au/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      paynowSupplierBusinessCode: 'RTCC',
      paynowSupplierBusinessCodePetsure: 'RTCC_PS'
    },
    bannerImage: {
      nonprod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/bg/bg-trupanion.webp',
      prod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/bg/bg-trupanion.webp'
    },
    customFaviconUrl: {
      nonprod:
        'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/favicon/trupanion-favicon.ico',
      prod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/favicon/trupanion-favicon.ico'
    },
    headerLogo: {
      nonprod: {
        imageUrl:
          'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/logo/trupanion-logo.png',
        imageTitle: '',
        imageTitleDescription: '',
        redirectUrl: CSPUrlsMap.dashboard.url
      },
      prod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/logo/trupanion-logo.png',
        imageTitle: '',
        imageTitleDescription: '',
        redirectUrl: CSPUrlsMap.dashboard.url
      }
    },
    footerLogo: {
      nonprod: {
        imageUrl:
          'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/footer/trupanion-footer.png',
        imageTitle: 'Trupanion Pet Insurance',
        imageTitleDescription: 'Trupanion Pet Insurance'
      },
      prod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/footer/trupanion-footer.png',
        imageTitle: 'Trupanion Pet Insurance',
        imageTitleDescription: 'Trupanion Pet Insurance'
      }
    },
    termsOfUseUrl:
      'https://petcdnstore.blob.core.windows.net/csp-common/pdfs/terms_of_use/Customer_Portal_Terms_of_Use_092024.pdf',
    header: {
      layoutConfig: {
        small: 'hamburger',
        large: 'horizontal'
      }
    },
    faqRedirection: {
      excessTooltip: {
        category: 'claims',
        question: 'How is my claim benefit calculated?'
      },
      editName: {
        category: 'policy management',
        question: `Why can't I edit my name in the Pet Portal?`
      },
      addYourVet: {
        category: 'getting started',
        question: 'Adding your vet to your account'
      }
    },
    gtm: {
      id: 'GTM-PNWLTVBD',
      dataLayer: 'dataLayer'
    },
    seo: {
      title: 'Trupanion - Pet Portal Login',
      description:
        'Access your Trupanion Pet Portal to manage your pet policy, access 24/7 Live Vet support and to submit and track your claims.'
    }
  }
};
